<template>
  <div>
    <van-nav-bar
      title="好友现金券"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div class="backgroud">
        <br>
        <br>
        <van-row >
          <van-col span="12">
            <div class="capital-box">
              <div class="capital-header">
                <img src="../assets/images/timebao.png" alt="">
                <h5>余额</h5>
              </div>
              <br>
              <p>{{ amountPlus.toFixed(2) }} 元</p>
            </div>
          </van-col>
          <van-col span="12"
            ><div class="capital-box">
              <van-button type="danger" color="#e30f1d" style="margin-left: 75px; margin-top: -40px;" round size="mini" @click="goPage"
                >使用须知</van-button
              >
            </div></van-col
          >
        </van-row>
    </div>
    <br>
    <div id="friendcoupontable">
        <div class="table-title">
        <div>赠送日期</div>
        <div>到期日期</div>
        <div>金额</div>
        <div>状态</div>
        <div>推广二维码/链接</div>
      </div>
      <van-loading v-if="isLoading" style="text-align:center;padding-top:20px;">加载中...</van-loading>
      <van-empty image="error" description="暂无好友现金券" v-if="isCoupon" />
      <div class="table-content" v-for="(item, index) in all_coupon" :key="index">
        <div>{{ item.approvetime }}</div> 
        <div>{{ item.effect_date }}</div>
        <div>{{ item.amount }}</div>
        <div>{{ item.statustext }}</div>
        <div>
          <span v-if="item.status == 1"
            ><van-button
              type="danger"
              color="#e30f1d"
              round
              size="mini"
              @click="goDetails(item.coupon)"
              style="border-radius: 5px; width: 60px; height: 20px; font-size: 10px;"
              >详情</van-button
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FriendCoupon",
  data() {
    return {
      all_coupon: [],
      amountPlus: 0,
      isCoupon: false,
      isLoading:false,
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    friendCoupon() {
      let that = this;
      that.isLoading=true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "friend_coupon",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          that.isLoading=false;
          let resData = res.data;
          if (res.data.code === 1) {
            that.all_coupon = resData.data;
            if (that.all_coupon.length < 1) {
              that.isCoupon = true;
            }
            for (let i = 0; i < that.all_coupon.length; i++) {
              if (that.all_coupon[i].status === 1) {
                that.amountPlus = that.amountPlus + that.all_coupon[i].amount;
              }
            }
          } else {
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          that.isLoading=false;
        });
    },
    goPage() {
      this.$router.push({
        path: "/protocol",
        query: { type: 21 },
      });
    },
    goDetails(coupon) {
      sessionStorage.setItem("couponCode", coupon);
      this.$router.push({
        
        path: '/member/agency', 
        query: { redirectTo: 'AgencyLink' }
      });
}

  },
  mounted: function () {
    let that = this;
    this.isLogin();
    this.friendCoupon();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.custom-title {
  color: #D02E27;
}
.table-content,
.table-title {
  width: 100%;
  overflow: hidden;
}
.table-title > div {
  width: 18%;
  float: left;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  font-weight: bold; 
  border-bottom: 1px solid #f0f0f0;
}
.table-content > div {
  width: 18%;
  float: left;
  padding: 10px 0;
  text-align: center;
  font-size: 11px;
  color: #707070;
}
.table-content > div:last-child {
  width: 28% !important;
}
.table-title > div:last-child {
  width: 28% !important;
}
.backgroud {
    margin:10px 10px 5px 10px !important;
    border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
    align-items: center;
    overflow: hidden;
    height: 130px;
  }
  .capital-box {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital-box h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  color: #000000;
}

.capital-box p {
  margin: 0px 0px 0px -30px;
  color: #D02E27;
  font-size: 18px;
  font-weight: bold;
  text-align: left;  
  width: 100px;  
  min-width: 100px;  
  display: inline-block;  
}

.capital-header {
  display: flex;
  align-items: center; /* Align items in the same line */
  margin-left: -80px;
}

.capital-header img {
  width: 25px;  
  height: 25x; 
  margin-right: 5px; 
  margin-top: -2px;
}
#friendcoupontable{
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/FriendCoupon.vue